// About.js
import React from "react";
import Page from "../Layouts/Pages";

const About = () => {
  return (
    <Page
      pageContent={(
        <>
          <h1>About Us</h1>
          Other content specific to the About page
        </>
  )}
    />
  );
};

export default About;
